<template>
  <section class="learning-path-content">
    <div class="learning-path-content__container">
      <Topic
        v-for="(topic, i) in learningPath.content"
        :key="i"
        :topic="topic"
        :order="i + 1"
        :hasAccess="hasAccess"
        :unSubscribedLink="unSubscribedLink"
        :learningAreaName="learningAreaName"
        :learningAreaColor="learningAreaColor"
        :levelOpen="levelOpen"
        :topicIndex="i"
        @openLevel="openLevel"
      />
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import { getLearningAreaSnipeColor, getLearningAreaName } from '@/helpers'
import Topic from './Topic.vue'

export default {
  name: 'ContentSection',
  components: {
    Topic,
  },
  props: {
    learningPath: {
      type: Object,
      required: true,
    },
    hasAccess: {
      type: Boolean,
      required: true,
    },
    unSubscribedLink: {
      type: String,
      required: true,
    },
    levelOpen: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState({
      nextContent: state => state.learningPaths.nextContent,
      plansLink: state => state.app.plansLink,
      isAuthenticated: state => state.auth.isAuthenticated,
      currentScoredAttempt: state => state.certifications.currentScoredAttempt,
    }),
    learningAreaName() {
      return getLearningAreaName(this.learningPath)
    },
    learningAreaColor() {
      return getLearningAreaSnipeColor(this.learningAreaName)
    },
  },
  methods: {
    openLevel(topicIndex, levelId) {
      this.$emit('openLevel', topicIndex, levelId)
    },
  },
}
</script>

<style lang="scss" scoped>
.learning-path-content {
  display: flex;
  justify-content: center;
  color: var(--white);
  background: linear-gradient(0deg, #111111, #111111),
    linear-gradient(180deg, #111111 0%, rgba(17, 17, 17, 0) 15.27%);
  padding: 60px 20px;

  @include desktop {
    padding: 60px 100px;
  }

  &__container {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    flex: 1;
    max-width: 1400px;
  }
}
</style>
